import { createTheme, ThemeOptions } from "@mui/material/styles";
import { pink, yellow, red, blue, green } from "@mui/material/colors";

import {
  brandPrimary,
  brandPrimaryFocus,
  brandSecondary,
  brandSecondaryFocus,
} from "../../../constants";

// Extend the Palette interface to include 'focus' property
declare module "@mui/material/styles" {
  interface Palette {
    focus?: string;
  }

  interface PaletteOptions {
    focus?: string;
  }

  interface PaletteColor {
    focus?: string;
  }

  interface PaletteColorOptions {
    focus?: string;
  }
}

// Create the theme object first to access the palette
const { palette } = createTheme();

const customTheme: ThemeOptions = {
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "rgb(51, 54, 57)",
          },
        },
      },
    },
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    pinky: palette.augmentColor({ color: pink }) as { main: string; light: string; dark: string },
    summer: palette.augmentColor({ color: yellow }) as { main: string; light: string; dark: string },
    primary: {
      main: brandPrimary,
      focus: brandPrimaryFocus,  // Now valid because we've extended the Palette type
      dark: brandPrimaryFocus,
      contrastText: "#ffffff",
      text: "#212529",
    },
    secondary: {
      main: brandSecondary,
      focus: brandSecondaryFocus,  // Now valid
      contrastText: "#ffffff",
    },
    success: palette.augmentColor({ color: green }) as { main: string; light: string; dark: string },
    warning: palette.augmentColor({ color: yellow }) as { main: string; light: string; dark: string },
    danger: palette.augmentColor({ color: red }) as { main: string; light: string; dark: string },
    link: palette.augmentColor({ color: blue }) as { main: string; light: string; dark: string },
    light: {
      main: "#ffffff",
      focus: "#ffffff",  // Custom 'focus' property is allowed
      light: "#ffffff",
      dark: "#ffffff",
      contrastText: "#212529",
    },
    dark: {
      main: "#ffffff",
      focus: "#ffffff",  // Custom 'focus' property is allowed
      light: "#ffffff",
      dark: "#ffffff",
      contrastText: "#ffffff",
      text: "#212529",
    },
    grey: {
      main: "rgba(233, 233, 233, 0.1)",
      focus: "rgba(233, 233, 233, 0.1)",  // Custom 'focus' property is allowed
      light: "rgba(233, 233, 233, 0.1)",
      dark: "rgba(233, 233, 233, 0.1)",
      contrastText: "rgba(233, 233, 233, 0.1)",
      text: "rgba(233, 233, 233, 0.1)",
    },
    white: {
      main: "#ffffff",
      focus: "#ffffff",  // Custom 'focus' property is allowed
      light: "#ffffff",
      dark: "#ffffff",
      contrastText: "#ffffff",
      text: "#ffffff",
    },
    mode: "dark",
    type: "dark",
    background: {
      default: "#000000",
      paper: "rgb(22, 24, 28)",
    },
    mixins: {
      toolbar: {
        minHeight: 64,
      },
    },
  },
};

export default customTheme;